import { render } from "./TextLoader.vue?vue&type=template&id=c6499788&scoped=true"
import script from "./TextLoader.vue?vue&type=script&lang=js"
export * from "./TextLoader.vue?vue&type=script&lang=js"

import "./TextLoader.vue?vue&type=style&index=0&id=c6499788&scoped=true&lang=css"

import exportComponent from "/Users/matthewnorth/Documents/Projects/ip-address-tracker-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6499788"]])

export default __exports__